<script>
import MargettsApi from "../../../modules/margetts-api";
import Widget from '../../Widget.vue';
import {nextTick} from "vue";
import {useSearchableSelector} from "../../../composables/useSearchableSelector";

export default {
    name: "SelectInvestor",
    extends: Widget,
    emits: ["emitSelectedInvestor", "isLoading", "emitClearInvestorDetails"],
    data() {
        return {
            investor: null,
            newInvestorFlag: false,
            investorDetails : {},
            investorList: [],
        }
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            this.$emit('emitClearInvestorDetails');
            this.fetchInvestorLists();
        },

        async fetchInvestorLists() {
            this.$emit("isLoading", true);
            if (this.investorList.length === 0) {
                const { data } = await axios.get('investment-application/investors-lists');
                let responseData = data;

                if ( ! responseData || ! responseData.result) {
                    return MargettsApi.throwNoResponseError();
                }

                if (responseData.result !== 'success') {
                    return this.throwApiError(responseData.messages);
                }

                this.investorList = responseData.data;
            }

            if (this.investorList.length > 0) {
                const { initSearchableSelector } = useSearchableSelector()
                await nextTick();
                initSearchableSelector("investorList");
            }

            this.$emit("isLoading", false);
        },

        updateInvestor(event) {
            if (event.target.value) {
                this.investor = event.target.value;
                this.start()
            }
        },

        async start() {
            this.$emit('isLoading', true);
            try {
                const { data:response } = await axios.get('investment-application/investors-details', {
                    params: {
                        'investor': this.investor,
                    }
                });
                if (!response || !response.result) {
                    return MargettsApi.throwNoResponseError();
                }

                if (response.result !== 'success') {
                    return this.throwApiError(response.messages);
                }

                const data = response.data;

                this.investorDetails = {
                    investorDetails: { ...data },
                    page: 3,
                    newInvestorFlag: false
                };

                await nextTick();
                this.$emit('emitSelectedInvestor', this.investorDetails);
            } catch(error) {
                MargettsApi.throwError(error);
            }
            this.$emit('isLoading', false);
        },

        newInvestor() {
            this.investorDetails = { page: 3, newInvestorFlag: true };
            this.$emit('emitSelectedInvestor', this.investorDetails);
        },

        previous() {
            this.$emit('emitSelectedInvestor', 1)
        }
    }
}
</script>

<template>
<section>
    <form>
        <div v-if="investorList.length" class="form-group form-group-selectr">
            <label for="investor">
                Select an existing investor or click next to proceed with a new investor
            </label>
            <select id="investorList" class="form-control" name="" @change="updateInvestor" required>
                <option value="">Select an investor</option>
                <option v-for="item in investorList" :value="item.id" :key="item.id">
                    {{ item.displayName }}
                </option>
            </select>
        </div>
        <div v-else class="form-group">
            <span class="alert alert-warning" style="padding: 10px">
                No Investor returned for this adviser, click next to proceed with a new investor.
            </span>
        </div>

        <div class="form-group investment-application-navigation-controls">
            <button type="button" class="button button-info" @click.stop="previous()">
                Previous
            </button>

            <button type="button" class="button button-primary" @click.prevent="newInvestor()">
                Next
            </button>
        </div>
    </form>
</section>
</template>

<style scoped>
 .form-margin-2em {
     margin: 2em 0 !important;
 }
</style>
